import React from 'react'
import LogoutIcon from 'assets/svg/top_menu/logout.svg'
import { useLoginCallbackHook } from 'hooks'

import styled from 'styled-components'
import { Gap, Size } from 'const'
import _ from 'lodash'

const Logout = ({ onClick, icon = LogoutIcon, text = 'ログアウト', style = { marginTop: '20px' } }) => {
  const { execLogOut } = useLoginCallbackHook()

  return (
    <LogoutBlock style={style} onClick={_.debounce(() => execLogOut(), 300)}>
      <button className="btn">
        <span>{text}</span>
        <img alt="logout icon" src={icon} />
      </button>
    </LogoutBlock>
  )
}

const LogoutBlock = styled.div`
  text-align: center;

  .btn {
    font-size: ${Size.FONT.BIGGER};
    color: inherit;
    font-weight: 700;
    text-decoration: underline;
    background: none;
    border: none;
    cursor: pointer;
    display: inline-flex;
    gap: ${Gap.MD};
    align-items: center;
    font-family: inherit;

    img {
      max-height: 20px;
      width: 20px;
    }
  }
`

export default Logout
